import React, { useEffect, useState } from 'react'
import { Select, message } from 'antd';
import PlacesAutocomplete, { geocodeByAddress, geocodeByPlaceId, getLatLng } from 'react-places-autocomplete';
import { locationOutline, search_icon } from '../../assets/images';
const { Option } = Select;

const FilterNetwork = ({updateServices, setLocation, value, setValue, loading}) => {

  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);

  const new_script = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.addEventListener('load', () => setGoogleMapsLoaded(true));
    script.addEventListener('error', (e) => console.error('Error loading Google Maps API', e));
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (!googleMapsLoaded) {
      new_script('https://maps.googleapis.com/maps/api/js?key=AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ&libraries=places');
    }
  }, [googleMapsLoaded]);
 
  if (!googleMapsLoaded) {
    return null; // Render nothing until Google Maps is loaded
  }

  const allServiceModes = [
   { key: 'home_collection', value: 'Home collection' },
   { key: 'in_clinic', value: 'In clinic' }
  ]

  const allServiceTypes = [
    { key: 'ahc', value: 'Body' },
    { key: 'dental', value: 'Dental' },
    { key: 'vision', value: 'Vision' }
  ]

  const handleSelect = async (selected, placeId) => {
    const results = await geocodeByAddress(selected);
    const latLng = await getLatLng(results[0]);
    const [place] = await geocodeByPlaceId(placeId);
    const { long_name: postalCode = '' } = place.address_components.find(c => c.types.includes('postal_code')) || {};
    setValue(selected);
    setLocation(latLng.lat, latLng.lng, postalCode); 
  }

  const renderSuggestionsDropdown = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
    <div className="autocomplete-root relative ">
      <div className={'flex border-gray-200 bg-white border '} >
        <img src={search_icon} className='inline-block ml-3 mr-2' />
        <input {...getInputProps()} placeholder={'Ex - Ekincare or Banglore'} style={{ borderColor: 'transparent'}} className='location text-gray-600 text-base leading-4 align-baseline w-full border-transparent pl-0 mr-1'/>
      </div>
      <div className={`autocomplete-dropdown-container ${suggestions.length > 0 ? `border-gray-200 border rounded-md mt-2` : ''}`}>

        {suggestions.map((suggestion, index) => (
          <div className=''>
          <div key={index} className='p-2 text-gray-600 bg-white flex items-center hover:bg-gray-100 hover:text-gray-900 ' {...getSuggestionItemProps(suggestion)}>
            <img src={locationOutline} className='h-5 mr-2'/>
            <span className='cursor-pointer '>{suggestion.description}</span>
          </div>
          <hr size="8" width="100%"></hr>
          </div>
          
        ))}
      </div>
    </div>
  );

  const handleLoadError = (error) => {  
    error === 'ZERO_RESULTS' ? message.error('Location not found' ) : console.error('Error loading Google Maps API', error)
  }

  return (
    <div className='flex justify-between w-full'>
      <div className='w-2/6' style={{zIndex: 3}}>
        <label className="font-semibold mb-4 block text-gray-700">Enter location or pincode</label>

      <PlacesAutocomplete
        value={value}
        onChange={setValue}
        onSelect={handleSelect}
        onEnterKeyDown={handleSelect}
        onError={handleLoadError}
        debounce={500}
        shouldFetchSuggestions={value?.length > 2}
        searchOptions={{componentRestrictions: { country: 'IN' }}}
      >{renderSuggestionsDropdown}
      </PlacesAutocomplete>
      </div>
      <div className='w-3/12'>
        <label className="font-semibold mb-4 block text-gray-700">Select service type</label>
        <Select
          mode="multiple"
          style={{ width: '100%', background: '#FFF'}}
          placeholder="Ex - Body"
          name={'service_types'}
          onChange={(value) => updateServices(value, 'service_types')}
          allowClear
          disabled={loading}
        >
          {allServiceTypes.map((type, index) => <Option key={index} value={type.key}>{type.value}</Option>)}
        </Select>
      </div>
      <div className='w-3/12'>
        <label className="font-semibold mb-4 block text-gray-700">Select service mode</label>
        <Select
          style={{ width: '100%', background: '#FFF'}}
          placeholder="Ex - Home collection"
          onChange={(value) => updateServices(value, 'service_modes')}
          allowClear
          disabled={loading}
        >
          {allServiceModes.map((type, index) => <Option key={index} value={type.key}>{type.value}</Option>)}
        </Select>
      </div>
    </div>
  )
}

export default FilterNetwork